module.exports = __webpack_public_path__ + "ee06b598d48901118f0d745a95f3eaf0.jpg";


//////////////////
// WEBPACK FOOTER
// ../~/file-loader!../loaders/scale-loader?size=410!./images/broschuere21_image.jpg
// module id = 467
// module chunks = 0